import React, { useMemo } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";

const StatsCard = ({ clientsList = [] }) => {
    const stats = useMemo(() => {
        const total = clientsList.length;
        const active = clientsList.filter(c => ["Active", "Verified"].includes(c.status)).length;
        const inactive = clientsList.filter(c => ["Inactive", "Suspended", "Pending"].includes(c.status)).length;

        return [
            { title: "Total Clients", value: total, icon: "🏢", color: "#00a8e1", bgColor: "#f0faff" },
            { title: "Active/Verified", value: active, icon: "📋", color: "#28a745", bgColor: "#f0fff4" },
            { title: "Inactive/Suspended/Pending", value: inactive, icon: "⚡", color: "#f43f5e", bgColor: "#fff1f2" },
        ];
    }, [clientsList]);

    return (
        <Row className="mb-4 g-4">
            {stats.map((stat, index) => (
                <Col key={index} xl="4" md="6">
                    <Card className="shadow-sm border-0 h-100" style={{ borderRadius: "12px" }}>
                        <CardBody className="d-flex align-items-center p-3">
                            <div className="d-flex align-items-center justify-content-center me-3"
                                style={{ minWidth: "48px", height: "48px", backgroundColor: stat.bgColor, borderRadius: "10px", fontSize: "22px", color: stat.color }}>
                                {stat.icon}
                            </div>
                            <div>
                                <p className="text-muted mb-0 fs-6 fw-medium small">{stat.title}</p>
                                <h4 className="fw-bold mb-0">{stat.value}</h4>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default StatsCard;